/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Link } from "react-router-dom";
import { Table, Text, FlexContainer, theme } from "@nordcloud/gnui";
import {
  DistinctPatchFailureItemFragment,
  ResourceStatus,
} from "~/generated/graphql";
import { ROUTES } from "~/routing/routes";
import { ResourceDetailsStatus } from "~/views/resources/ResourceDetails/components/ResourceDetailsStatus";
import { countCellCss, iconCellCss, nameCellCss } from "./styles";

type Props = {
  failure: DistinctPatchFailureItemFragment;
};

export function DistinctUpdateFailuresRow({ failure }: Props) {
  const { resourceId, resourceName, distinctFailureCount, resource } = failure;

  const status = resource?.state?.status ?? ResourceStatus.Online;

  return (
    <Table.tr>
      <Table.td css={iconCellCss}>
        <FlexContainer alignItems="center">
          <ResourceDetailsStatus
            os={resource?.os}
            status={status}
            iconSize="md"
            boxes={false}
          />
        </FlexContainer>
      </Table.td>
      <Table.td css={nameCellCss}>
        <Link to={ROUTES.resources.generateDetails(resourceId)}>
          {resourceName}
        </Link>
      </Table.td>
      <Table.td css={countCellCss}>
        <FlexContainer css={{ width: "100%" }} justifyContent="flex-start">
          <Text tag="span" color={theme.color.support.red} mb={0}>
            {distinctFailureCount}
          </Text>
        </FlexContainer>
      </Table.td>
    </Table.tr>
  );
}
